/**
 * Маппинг URL путей для React Router
 * Централизованное управление всеми путями приложения
 */

/**
 * Константы путей для типобезопасной навигации
 */
export const ROUTE_PATHS = {
  // Auth страницы
  WELCOME: '/',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Home страницы (после авторизации)
  // WELCOME (`/`) — для неавторизованных, HOME_FEED (`/feed`) — для авторизованных.
  // Разделены на разные path'ы, чтобы один роутер корректно обрабатывал оба случая.
  HOME_FEED: '/feed',
  HOME_SELECTIONS: '/selections',
  HOME_POPULAR: '/popular',
  HOME_WISHLISTS: '/wishlists',

  // Подборки
  SELECTION_DETAIL: '/selections/:selectionId',
  SELECTION_ITEM_DETAIL: '/selections/:selectionId/item/:itemId',

  // Мои вишлисты
  MY_WISHLISTS: '/my-wishlists',
  WISHLIST_DETAIL: '/wishlist/:id',
  WISHLIST_NEW: '/wishlist/new',
  WISHLIST_EDIT: '/wishlist/:id/edit',

  // Желания (items)
  ITEM_DETAIL: '/wishlist/:wishlistId/item/:itemId',
  ITEM_NEW: '/wishlist/:wishlistId/item/new',
  /** Создание желания без предвыбранного вишлиста (пользователь выберет сам) */
  ITEM_NEW_GENERIC: '/item/new',
  ITEM_NEW_PREFILLED: '/item/new/prefilled',
  ITEM_EDIT: '/wishlist/:wishlistId/item/:itemId/edit',

  // Community
  COMMUNITY: '/community',
  USER_PROFILE: '/user/:userId',
  USER_WISHLISTS: '/user/:userId/wishlists',
  USER_ITEMS: '/user/:userId/items',

  // Profile
  PROFILE: '/profile',
  PROFILE_EDIT: '/profile/edit',
  MY_ITEMS: '/my-items',
  SETTINGS: '/settings',
  NOTIFICATIONS: '/notifications',
  CHANGE_PASSWORD: '/settings-change-password',
  APP_NOTIFICATIONS: '/settings-app-notifications',
  BLOCKED_USERS: '/settings-blocked-users',
  SETTINGS_LANGUAGE: '/settings-language',
  SETTINGS_CURRENCY: '/settings-currency',
  TERMS: '/settings-terms',
  PRIVACY_POLICY: '/settings-privacy-policy',
  SUPPORT: '/settings-support',
  DEBUG_COLORS: '/debug-colors',

  // Резервации
  BOOKINGS_LIST: '/bookings',

  // Тайный Санта
  SECRET_SANTA_LIST: '/secret-santa',
  SECRET_SANTA_NEW: '/secret-santa/new',
  SECRET_SANTA_DETAIL: '/secret-santa/:id',
  SECRET_SANTA_EDIT: '/secret-santa/:id/edit',
} as const;

/**
 * Хелперы для генерации путей с параметрами
 */
export const generatePath = {
  wishlistDetail: (id: string) => `/wishlist/${id}`,
  wishlistEdit: (id: string) => `/wishlist/${id}/edit`,
  itemDetail: (wishlistId: string, itemId: string) => `/wishlist/${wishlistId}/item/${itemId}`,
  itemNew: (wishlistId: string) => `/wishlist/${wishlistId}/item/new`,
  itemEdit: (wishlistId: string, itemId: string) => `/wishlist/${wishlistId}/item/${itemId}/edit`,
  userProfile: (userId: string) => `/user/${userId}`,
  userWishlists: (userId: string) => `/user/${userId}/wishlists`,
  userItems: (userId: string) => `/user/${userId}/items`,
  secretSantaDetail: (id: string) => `/secret-santa/${id}`,
  secretSantaEdit: (id: string) => `/secret-santa/${id}/edit`,
  selectionDetail: (selectionId: string) => `/selections/${selectionId}`,
  selectionItemDetail: (selectionId: string, itemId: string) => `/selections/${selectionId}/item/${itemId}`,
} as const;